import React from 'react';
import ReactTooltip from 'react-tooltip';

export function DashboardChartHeader(props) {
  const tooltipFor = 'tooltip-' + props.title.replace(/[^a-z0-9]+/g, '-');
  return (
    <div className="chart-inner-header">
      {props.title}
      <i className="info circle icon" data-tip data-for={tooltipFor}></i>
      <ReactTooltip id={tooltipFor}>
        {props.tooltip}
      </ReactTooltip>
    </div>
  );
}
